import { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth } from "../firebaseInit";
import defaultpfp from "../assets/spotify.svg";
import { AnimatePresence, motion } from "framer-motion";
import "../assets/stylesheets/navbar.css";
import "../assets/stylesheets/dropdown.css"

export default function Navbar() {
  const [pfp, setPfp] = useState(defaultpfp);
  const [user, setUser] = useState(null);
  const location = useLocation();
  const isHome = location.pathname === "/";

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user);
      if (user?.photoURL) setPfp(user.photoURL);
      else setPfp(defaultpfp);
    });
    return () => unsubscribe();
  }, []);

  const handleSignOut = async () => {
    try {
      await signOut(auth);
      window.location.href = "/";
    } catch (err) {
      console.error("Sign-out error:", err);
    }
  };

  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => setIsOpen((prev) => !prev);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <header className="navbar">
      <nav className="nav-buttons">
        <a href="/" className="logo">Sharify</a>
      </nav>

      {isHome && (
        <input type="text" className="search-bar" placeholder="Search here" />
      )}

      <nav className="nav-buttons">
        <a href="/" className="nav-btn">Home</a>
        <a href="/friends" className="nav-btn">Friends</a>
        <a href="/following" className="nav-btn">Following</a>

        {user ? (
          <>
            <div style={{position: "relative"}} ref={dropdownRef}>
              <img src={pfp} alt="Profile" className="pfp" onClick={toggleDropdown} />
              <AnimatePresence>
                {isOpen &&
                  <motion.div
                    key="dropdown"
                    initial={{ opacity: 0, y: -5 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -5 }}
                    transition={{ duration: 0.15 }} 
                    className="drop">
                    <h4>{user.displayName}</h4>
                    <a className="dropItem" href="/profile">Profile</a>
                    <a className="dropItem">Settings</a>
                    <a className="dropItem" onClick={handleSignOut}>Sign Out</a>
                  </motion.div>}
              </AnimatePresence>
            </div>
          </>
        ) : (
          <a href="/login" className="nav-btn sign-in">
            Sign In
          </a>
        )}
      </nav>
    </header>
  );
}
